function Logo() {
  document.body.style.backgroundImage                 = "url('fondo.png')";
  document.body.style.backgroundAttachment            = "fixed";
  document.body.style.backgroundSize                  = "cover";

  return <></>;
}

export { Logo };